module.exports = __webpack_public_path__ + "static/img/chart.36894849.svg";